import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { diffWords } from "diff";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeCompare } from "@fortawesome/free-solid-svg-icons";

export const DiffModal: React.FC<{ oldText: string; newText: string }> = ({ oldText, newText }) => {
    const [show, setShow] = useState(false);

    // Compute the differences
    const diff = diffWords(oldText, newText);

    return (
        <>
            {/* Button to open the modal */}
            <Button className="float-end" style={{marginRight: '4px'}} variant="outline-secondary" size="sm" onClick={() => setShow(true)}>
                <FontAwesomeIcon icon={faCodeCompare} /> Show Diff
            </Button>

            {/* Bootstrap Modal */}
            <Modal show={show} onHide={() => setShow(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Text Differences</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {diff.map((part, index) => (
                            <span
                                key={index}
                                style={{
                                    backgroundColor: part.added ? "lightgreen" : part.removed ? "salmon" : "transparent",
                                    textDecoration: part.removed ? "line-through" : "none",
                                    padding: "2px",
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {part.value}
                            </span>
                        ))}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
